module.exports = __webpack_public_path__ + "img/subopeninactive.d8bc2b32.svg";